/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
  name: "EditLabtest",
  props: { id: String },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      selectedLabId: this.studyid,
      isEditMode: false,
      location: "",
      values: {
        testCode: "",
        testName: "",
        unit: "",
        category: "",
        method: "",
        cdiscVariable: "",
        fhirResource: "",
        fhirCode: {
          system: "http://loinc.org", 
          code: "",
          display: ""
        },
        active: true,
        allowUnitConversion: false,
      },
      errors: [true, true],
    };
  },

  mounted() {
    this.isEditMode = this.id != 0;
    if (this.isEditMode) {
      this.retrieveLabInfo();
    } else {
      this.getStudyDetails();

      this.values.fhirCode.system = "http://loinc.org";
    }
  },

  methods: {
    async getStudyDetails() {
      const idtoken = store.getters.getIdToken;
      let studyid = store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/getbyid?id=${studyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.values.studyId = res.data.studyId;
        this.values.studyRef = res.data.studyRef;
      } catch (err) {
        console.error("Error in getStudyDetails:", err);
      }
    },

    async retrieveLabInfo() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/management/labtest/getbyid?id=${this.id}&StudyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.values = response.data;
        this.values.fhirCode.system = "http://loinc.org";
      } catch (err) {
        console.error("Failed to fetch lab info:", err);
      }
    },

    async addLab() {
      if (this.id == 0) {
        this.saveLab();
      } else {
        this.editLab();
      }
    },

    async saveLab() {
  this.validate();
  if (this.errors.includes(false)) return;

  const idtoken = store.getters.getIdToken;
  let errorMessage = "Creation failed";
  let showAlert = false;

  try {
    await axios.post(
      `${this.baseurl}/management/labtest/create`,
      this.values,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    alert(this.$t("navigations.lab test created successfully"));
    this.$router.push(`/labTest`);
  } catch (err) {
    if (err.response?.data?.messages?.length) {
      let fullMsg = err.response.data.messages[0];
      let shortMsg = fullMsg.includes(":") ? fullMsg.split(":")[1].trim() : fullMsg;
      shortMsg = shortMsg.split("\n")[0].trim();

      if (/Lab test already exists/i.test(fullMsg)) {
        errorMessage = "Lab test already exists.";
        showAlert = true;
      } else if (/Duplicate/i.test(fullMsg)) {
        errorMessage = "Duplicate entry detected.";
        showAlert = true;
      } else {
        console.error("Server Error:", shortMsg);
      }
    } else if (err.response?.data?.detail) {
      errorMessage = err.response.data.detail;
      console.error("Error detail:", err.response.data.detail);
      showAlert = true;
    } else {
      console.error("Unhandled Error:", err);
      showAlert = true;
    }

    if (showAlert) {
      alert(errorMessage);
    }
  }
}
,

    async editLab() {
      this.validate();
      if (this.errors.includes(false)) return;

      let payload = {
        testId: this.values.id,
        testCode: this.values.testCode,
        testName: this.values.testName,
        unit: this.values.unit,
        category: this.values.category,
        allowUnitConversion: this.values.allowUnitConversion,
        method: this.values.method,
        cdiscVariable: this.values.cdiscVariable,
        fhirResource: this.values.fhirResource,
        fhirCode: this.values.fhirCode,
        studyId: this.values.studyId,
        active: this.values.active,
      };

      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(
          `${this.baseurl}/management/labtest/update`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        alert(this.$t("navigations.lab test updated successfully"));
        this.$router.push(`/labTest`);
      } catch (err) {
        alert(err.response?.data?.detail || "Update failed");
      }
    },

    validate() {
      this.values.testCode = this.values.testCode.replace(/ +/g, " ").trim();
      this.values.testName = this.values.testName.replace(/ +/g, " ").trim();
      this.values.unit = this.values.unit?.replace(/ +/g, " ").trim();
      this.values.category = this.values.category?.replace(/ +/g, " ").trim();
      this.values.method = this.values.method?.replace(/ +/g, " ").trim();
      this.values.cdiscVariable = this.values.cdiscVariable?.replace(/ +/g, " ").trim();
      this.values.fhirResource = this.values.fhirResource?.replace(/ +/g, " ").trim();
     
      this.values.fhirCode.code = this.values.fhirCode.code?.replace(/ +/g, " ").trim();
      this.values.fhirCode.display = this.values.fhirCode.display?.replace(/ +/g, " ").trim();
    
      this.errors[0] = this.values.testCode !== "";
      this.errors[1] = this.values.testName !== "";
    },

    onclosed() {
      this.$router.push(`/labTest`);
    },

    clear() {
      this.values = {
        testCode: "",
        testName: "",
        unit: "",
        category: "",
        method: "",
        cdiscVariable: "",
        fhirResource: "",
        fhirCode: { 
          system: "http://loinc.org", 
          code: "", 
          display: "" 
        },
        active: true,
        allowUnitConversion: false,
      };
      this.errors = [true, true];
    },
  },
};